export interface BdFooterOptions {
  privacy: {
    enabled: boolean;
    link: string;
  };
  documentation: {
    enabled: boolean;
    link: string;
  };
  siteNotice: {
    enabled: boolean;
    link: string;
  };
  status: {
    enabled: boolean;
    link: string;
  };
}

export const BD_FOOTER_OPTIONS_DEFAULT: BdFooterOptions = {
  privacy: {
    enabled: true,
    link: 'https://www.bindoc.de/datenschutz',
  },
  documentation: {
    enabled: true,
    link: 'https://bindoc.atlassian.net/wiki/spaces/HP/overview',
  },
  siteNotice: {
    enabled: true,
    link: 'https://www.bindoc.de/impressum',
  },
  status: {
    enabled: false,
    link: 'https://status.bindoc.de/',
  },
};
